<template>
  <div class="c-main--flex-1">
    <h2 class="c-title c-title--page">{{$t('organisation.addUser')}}</h2>
    <div v-if="phase === 'email'" class="o-layout">
      <div class="o-layout__item u-1-of-2-at-small">
        <sceEmailField label="user.email" v-model="email" />
      </div>
      <div class="o-layout__item">
        <sceRouteButton :route="{name: 'organisation.users'}" label="cancel" />
        <sceButton label="next" @click="checkEmail()" class="c-button--primary" />
      </div>
    </div>
    <div v-if="phase === 'emailExists'" class="o-layout">
      <div class="o-layout__item">
        <!-- TODO check if the user is already in the organisation -->
        <p>
          {{$t('organisation.emailExists')}}
        </p>
        <p>
          <strong>{{ email }}</strong>
        </p>
        <p>
          {{$t('organisation.emailExistsAddUser')}}
        </p>
      </div>
      <div class="o-layout__item">
        <sceSelect v-model="role" label="role" :options="$options.roleOptions" />
      </div>
      <div class="o-layout__item">
        <sceRouteButton :route="{name: 'organisation.users'}" label="cancel" />
        <sceButton label="addUser" @click="addUser()" class="c-button--primary" />
      </div>
    </div>
    <div v-if="phase === 'createUser'" class="o-layout">
      <div class="o-layout__item">
        <!-- TODO check if the user is already in the organisation -->
        <p>
          {{$t('organisation.createUser')}}
        </p>
        <p>
          <strong>{{ email }}</strong>
        </p>
      </div>
      <div class="o-layout__item u-1-of-2-at-small">
        <sceTextField v-model="username" label="username" />
      </div>
      <div class="o-layout__item u-1-of-2-at-small">
        <sceTextField v-model="fullname" label="fullname" />
      </div>
      <div class="o-layout__item u-1-of-2-at-small">
        <scePasswordField v-model="password" label="password" />
      </div>
      <div class="o-layout__item u-1-of-2-at-small">
        <sceSelect v-model="role" label="role" :options="$options.roleOptions" />
      </div>
      <div class="o-layout__item">
        <sceRouteButton :route="{name: 'organisation.users'}" label="cancel" />
        <sceButton label="addUser" @click="addUser()" class="c-button--primary" />
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config"
import options from "@/lib/options"

export default {
  name: "addUser",
  data: function() {
    return {
      phase: 'email',
      email: null,
      role: 'organiser',
      username: null,
      fullname: null,
      password: null,
    }
  },
  roleOptions: options.organisation.roleOptions,
  methods: {
    checkEmail: function() {
      if (this.email) {
        this.$http.get(config.root + '/organisations/' + this.$route.params.organisationId + '/check-user-email',
          {params: { email: this.email }}).then(result => {
            if (result.data.exists) {
              this.phase = 'emailExists'
            } else {
              this.phase = 'createUser'
            }
        })
      }
    },
    addUser: function() {
      const data = {
        email: this.email,
        role: this.role,
      }
      if (this.phase === 'createUser') {
        data.username = this.username
        data.name = this.fullname
        data.password = this.password
        data.existing = false
      }
      else {
        data.existing = true
      }

      this.$notify.notifyAsync(
        this.$http.post(config.root + '/organisations/' + this.$route.params.organisationId + '/add-user', {data}),
        this.$t('organisation.addUser.processing', {name: this.email}),
        () => {
          this.$router.push({name: 'organisation.users'})
          return this.$t('organisation.addUser.success', {name: this.email})
        },
        (err) => {
          return this.$t('organisation.addUser.error', {name: this.email, err: err.message})
        }
      )
    },
  },
}
</script>

<style scoped>

</style>
